import React from 'react';
import { Rating as PrimeRating, RatingProps } from 'primereact/rating';
import _ from 'lodash'
import { withFormikFormControl } from '../FormikFormControl';
import {extract, toIcon, wrapComponent} from "../utils";
import {FormPageFieldComponentDefaultProps} from "types/formPage";

export const Rating = ({extraConfig = {}, ...restProps}:RatingProps & FormPageFieldComponentDefaultProps) => {
  const {icons = {}} = extraConfig
  // console.log('**RATING**',extraConfig, icons)
  const comp = <PrimeRating cancelIcon={icons.cancel ? toIcon(icons.cancel) : 'pi pi-ban'} onIcon={icons.on ? toIcon(icons.on) : 'pi pi-star-fill'} offIcon={icons.off ? toIcon(icons.off) : 'pi pi-star'} {...extract({stars: undefined,cancel:true}, extraConfig, restProps)} />
  return  wrapComponent(comp, extraConfig)
};

export const RatingFormik = withFormikFormControl()(Rating);

export default RatingFormik;
